import { MouseEvent, useContext, useState } from 'react';
import JQuery from 'jquery';
import AppContext from '../../AppContext';
import Alert from '../common/Alert';
import Kundengruppe from '../../api-shop.constants';
import { appConfig } from '../../config';

function ArtikelInWarenkorb() {
  const { appData } = useContext(AppContext);
  const [count, setCount] = useState(1);

  const addFormField = (form: JQuery<HTMLFormElement>, name: string, value: string): void => {
    form.append($(`<input type="hidden" name="${name}" value="${value}">`));
  };

  const countUp = () => {
    setCount(count + 1);
  };

  const countDown = () => {
    setCount(Math.max(1, count - 1));
  };

  const intoCart = (e: MouseEvent) => {
    const target = $(e.target);
    const form = target.closest('form');
    const basket = $.evo.basket();
    if (basket) {
      addFormField(form, basket.options.input.id, appData.static.artikel.kArtikel.toString());
    }
    addFormField(form, 'wlPos', '0');
    addFormField(form, 'wke', '1');
    addFormField(form, 'show', '1');
    addFormField(form, 'kKundengruppe', '1');
    addFormField(form, 'kSprache', '1');
    addFormField(form, 'inWarenkorb', '1');
    Object.entries(appData.dynamic.selectedVariationWerte)
      .forEach(([kArtikelEigenschaft, wert]) => {
        addFormField(form, `eigenschaftwert[${kArtikelEigenschaft}]`, wert.toString());
      });
    form.submit();
    // Die Berechnung des Preises im Frontend ist rein informativ.
    // Anhand der gesendeten Werte für die Eigenschaften wird im Backend der Preis nochmal berechnet.
    // Siehe stm_configurator Plugin Bootstrap.php#setzePositionspreise()
    // Dieser Preis ist der, der im Warenkorb landet.
  };

  return (
    <div>
      <div className="mt-4">
        {appData.dynamic.invalid
          && (
            <Alert severity="error">
              Es scheint, als hätten Sie eine Fehlermeldung übersehen!
              <br />
              Bitte überprüfen Sie noch einmal Ihre Konfiguration
            </Alert>
          )}
        {!appData.dynamic.invalid
          && (appData.static.shop.kunde?.kKundengruppe === Kundengruppe.Mitarbeiter
            || !appData.static.artikel.funktionsAttribute
            || !Object.entries(appData.static.artikel.funktionsAttribute).find(([name, value]) => name === 'auf anfrage' && value === '1'))
          && (
            <div id="add-to-cart" className="product-buy">
              <div className="row basket-form-inline">
                <div className="col col-sm-6 col-12">
                  <div className="input-group form-counter choose_quantity" id="quantity-grp" role="group">
                    <div className="input-group-prepend ">
                      <button type="button" className="btn" aria-label="Menge verringern" data-count-down="" onClick={() => countDown()}>
                        <span className="fas fa-minus" />
                      </button>
                    </div>
                    <input
                      type="number"
                      className="form-control quantity"
                      id="quantity"
                      required
                      value={count}
                      onChange={() => {}}
                      min="0"
                      step="1"
                      name="anzahl"
                      aria-label="Menge"
                      data-decimals="0"
                      data-product-id={appData.static.artikel.kArtikel}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text unit form-control">
                        Stück
                      </div>
                      <button type="button" className="btn" aria-label="Menge erhöhen" data-count-up="" onClick={() => countUp()}>
                        <span className="fas fa-plus" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col col-sm-6 col-12">
                  <button
                    type="button"
                    className="btn js-cfg-validate btn-primary btn-block"
                    name="inWarenkorb"
                    value="In den Warenkorb"
                    aria-label="In den Warenkorb"
                    onClick={(e) => intoCart(e)}
                  >
                    { !appConfig.external
                      && (
                        <span className="btn-basket-check">
                          <span>In den Warenkorb</span><i className="fas fa-shopping-cart" />
                        </span>
                      )}
                    { appConfig.external
                      && (
                        <span className="btn-basket-check">
                          <span>Konfiguration abschließen und zurück</span>
                        </span>
                      )}
                  </button>
                </div>
              </div>
            </div>
          )}
      </div>
      {appData.static.artikel.funktionsAttribute
        && Object.entries(appData.static.artikel.funktionsAttribute).find(([name, value]) => name === 'auf anfrage' && value === '1')
        && (
          <div className="mt-4">
            {appData.static.shop.deutscheSprachvariablen.productDetails.aufAnfrage}
          </div>
        )}
      {appData.static.artikel.funktionsAttribute
        && Object.entries(appData.static.artikel.funktionsAttribute).find(([name, value]) => name === 'nicht verfügbar' && value === '1')
        && (
          <div className="mt-4">
            {appData.static.shop.deutscheSprachvariablen.productDetails.nichtVerfügbar}
          </div>
        )}
    </div>
  );
}

export default ArtikelInWarenkorb;
